import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    viewBox: "0 0 48 48"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M39.825 40.102c-.82.825-1.675 1.488-2.609 1.997-2.18 1.19-4.764 1.61-7.442 1.306-3.295-.375-6.653-1.72-9.913-3.816-2.312-1.487-4.458-3.24-6.283-5.145-3.321-3.19-5.97-6.946-7.56-10.883C4.27 19.24 3.942 15.103 5.5 11.594c.954-2.151 2.574-3.876 5.125-5.83.065-.054.125-.105.237-.202l.025-.022c.614-.535.937-.762 1.458-.925.607-.19 1.25-.14 1.858.113 1.02.425 1.905 1.256 2.763 2.417.62.84 1.097 1.75 1.666 3.07l.142.327c.632 1.452.87 2.21.877 3.21.008 1.063-.378 1.93-1.15 2.733-.105.11-.202.209-.368.378l-.072.073c-.666.68-.973 1.014-1.29 1.436-1.133 1.503-1.779 3.411-1.826 5.362-.058 2.424.936 4.961 2.594 6.7 2.871 2.737 7.505 3.482 10.883 1.681.717-.382 1.392-.922 2.078-1.639.097-.102.195-.21.34-.375l.128-.145c.492-.56.777-.846 1.167-1.124.915-.65 2.003-.776 3.228-.504.714.158 1.422.432 2.312.855.211.1.42.203.798.39 1.25.611 2.295 1.292 3.18 2.112 1.29 1.197 1.934 2.14 1.844 3.38-.053.763-.338 1.234-1.03 2.035l-.087.1-.127.15c-.611.856-1.275 1.59-2.43 2.752Z",
      clipRule: "evenodd"
    }
  )
);
var SvgCallFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var CallFilled_default = SvgCallFilled;

export { CallFilled_default as default };
